module.exports = __webpack_public_path__ + "img/how-rpc-work-4.e1af8383.png";